import { validateJsonResponse, validateTextResponse } from './APIUtils';

export const fetchContent = groupName => {
  const url = `/api/qikserve/gfc2/menuItemContent?groupName=${groupName}`;

  return fetch(url)
    .then(response => {
      return validateJsonResponse(response);
    })
    .then(json => {
      return json;
    })
    .catch(error => {
      throw new Error(error);
    });
};

export const fetchContentByContentId = contentId => {
  const url = `/api/qikserve/gfc2/menuItemContent/${contentId}`;

  return fetch(url)
    .then(response => {
      return validateJsonResponse(response);
    })
    .then(json => {
      return json;
    })
    .catch(error => {
      throw new Error(error);
    });
};

export const createContentItem = content => {
  const url = `/api/qikserve/gfc2/menuItemContent`;

  const request = {
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(content)
  };

  return fetch(url, request)
    .then(response => {
      return validateJsonResponse(response);
    })
    .then(json => {
      return json;
    })
    .catch(error => {
      throw new Error(error);
    });
};

export const updateContentItem = (id, content) => {
  const url = `/api/qikserve/gfc2/menuItemContent/${id}`;

  const request = {
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(content)
  };

  return fetch(url, request)
    .then(response => {
      return validateJsonResponse(response);
    })
    .then(json => {
      return json;
    })
    .catch(error => {
      throw new Error(error);
    });
};
export const deleteContentItem = id => {
  const url = `/api/qikserve/gfc2/menuItemContent/${id}`;
  const request = {
    method: 'delete'
  };
  return fetch(url, request)
    .then(response => {
      return validateTextResponse(response);
    })
    .then(text => {
      return text;
    })
    .catch(error => {
      throw new Error(error);
    });
};
export class ImportContentError extends Error {
  constructor(message, errors) {
    super(message);
    this.name = 'ImportContentError';
    this.errors = errors || [];
  }
}

const buildImportError = body =>
  new ImportContentError(
    body.message || 'Failed to import contents',
    (body.errors || []).map(({ rowNumber, reason }) => ({ rowNumber, reason }))
  );

const parseImportErrors = async response => {
  if (response.status === 413) {
    return new ImportContentError('File is too large.');
  }
  const contentType = response.headers.get('content-type') || '';
  try {
    if (contentType.includes('application/json')) {
      return buildImportError(await response.json());
    }
    const text = await response.text();
    return new ImportContentError(
      text || response.statusText || 'Failed to import contents'
    );
  } catch {
    return new ImportContentError('Failed to import contents');
  }
};

export const importContentCsv = async (groupName, file, existingStrategy) => {
  const url = `/api/qikserve/gfc2/menuItemContent/import?groupName=${encodeURIComponent(
    groupName
  )}&existingStrategy=${encodeURIComponent(existingStrategy)}`;

  const formData = new FormData();
  formData.append('file', file);

  const response = await fetch(url, {
    method: 'post',
    body: formData
  });

  if (!response.ok) {
    if (response.status === 403) {
      throw validateJsonResponse(response);
    }
    throw await parseImportErrors(response);
  }

  const body = await response.json();

  if (body.errors && body.errors.length > 0) {
    throw buildImportError(body);
  }

  return body;
};

export const uploadImage = (channelId, image) => {
  const url = `/api/qikserve/gfc2/upload/image?channelId=${channelId}`;

  let formData = new FormData();
  formData.append('file', image);

  const request = {
    method: 'post',
    body: formData
  };

  return fetch(url, request)
    .then(response => {
      return validateJsonResponse(response);
    })
    .then(json => {
      return json;
    })
    .catch(error => {
      throw new Error(error);
    });
};
